import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function getSessionId() {
  let sid = localStorage.getItem("fantini_session");
  if (!sid) {
    sid = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("fantini_session", sid);
  }
  return sid;
}

export const LOGO_URL = "/fantini-logo.png?v=2";

export function euro(n) {
  if (n === null || n === undefined || n === "") return "—";
  return "€ " + Number(n).toLocaleString("it-IT");
}

export const WHATSAPP_NUMBER = "393924495258"; // Fantini Next Mobility
export const WHATSAPP_NUMBERS = [
  { label: "+39 392 449 5258", number: "393924495258" },
  { label: "+39 393 138 7168", number: "393931387168" },
];
export const PHONE_NUMBERS = [
  { label: "+39 030 668 2677", sub: "Sede di Brescia", tel: "+390306682677" },
  { label: "+39 030 259 0861", sub: "Sede di Rezzato (BS)", tel: "+390302590861" },
];
export const CONTACT_EMAIL = "info@fantiniauto.com";

export function statusMeta(status) {
  const map = {
    disponibile: { label: "Disponibile", cls: "bg-forest/10 text-forest border-forest/20" },
    in_trattativa: { label: "In trattativa", cls: "bg-sand/20 text-clay border-sand/30" },
    temporaneamente_bloccata: { label: "Temporaneamente bloccata", cls: "bg-clay/15 text-clay border-clay/30" },
    venduta: { label: "Venduta", cls: "bg-ink/10 text-ink-soft border-ink/10" },
  };
  return map[status] || map.disponibile;
}
